import { FC } from "react"
import styles from './styles.module.css'
import { BiError } from "react-icons/bi";


type Props = {
  msg:string,
  type: 'alert' |'error'
}

const AlertComponentModal:FC<Props> = ({msg,type})=>{
  return(
    <div className={`${type === 'alert' ?styles.alert :  styles.error} ${styles.body}`}>
      <div>
      <BiError color={ `${type === 'alert' ?styles.alert :  styles.error}`} size={'24px'}/>
      </div>
      <span className={styles.msg}>{msg}</span>
    </div>
  )
}

export {AlertComponentModal}